import { createContext } from 'react';
import { Gesture } from 'react-native-gesture-handler';
const InternalContext = createContext({
    animatedPathProps: {},
    animatedPathStyle: {},
    animatedCurrentPriceCircleProps: {},
    gestureEnabled: false,
    width: 0,
    height: 0,
    pathProps: {},
    longPressGesture: Gesture.LongPress(),
    animatedStrokeProps: {},
});
export default InternalContext;
